export default __webpack_public_path__ + "static/media/image22744.b6f02ab9.png";